(function () {
  'use strict';

  var resizeTimer = null;

  function syncToggleLabel(wrap, button, expanded) {
    var moreLabel = button.getAttribute('data-label-more') || 'READ MORE';
    var lessLabel = button.getAttribute('data-label-less') || 'READ LESS';
    button.textContent = expanded ? lessLabel : moreLabel;
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function updateReviewToggle(wrap) {
    var body = wrap.querySelector('.cc-blog-review__excerpt');
    var button = wrap.querySelector('.cc-blog-review__read-more');
    if (!body || !button) return;

    var wasExpanded = wrap.getAttribute('data-expanded') === 'true';

    wrap.setAttribute('data-expanded', 'false');
    void body.offsetHeight;

    var overflows = body.scrollHeight > body.clientHeight + 1;

    if (!overflows) {
      wrap.setAttribute('data-expanded', 'false');
      button.hidden = true;
      syncToggleLabel(wrap, button, false);
      return;
    }

    button.hidden = false;
    wrap.setAttribute('data-expanded', wasExpanded ? 'true' : 'false');
    syncToggleLabel(wrap, button, wasExpanded);
  }

  function initReviewToggles(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-cc-review-toggle]').forEach(updateReviewToggle);
  }

  function getSpaceBetween() {
    return window.matchMedia('(min-width: 750px)').matches ? 14 : 10;
  }

  function initReviewMediaSlider(mediaEl) {
    if (!mediaEl || typeof window.Swiper === 'undefined') return;

    var swiperEl = mediaEl.querySelector('[data-cc-review-swiper]');
    if (!swiperEl) return;

    var slideCount = Number(mediaEl.getAttribute('data-slide-count') || 0);
    if (!slideCount) {
      slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
    }
    if (slideCount < 1) return;

    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }

    var enableNav = slideCount > 2;
    var prevButton = mediaEl.querySelector('[data-cc-review-prev]');
    var nextButton = mediaEl.querySelector('[data-cc-review-next]');

    new window.Swiper(swiperEl, {
      slidesPerView: Math.min(2, slideCount),
      spaceBetween: getSpaceBetween(),
      watchOverflow: true,
      speed: 400,
      grabCursor: enableNav,
      allowTouchMove: enableNav,
      navigation:
        enableNav && prevButton && nextButton
          ? {
              nextEl: nextButton,
              prevEl: prevButton
            }
          : false,
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous images',
        nextSlideMessage: 'Next images'
      },
      breakpoints: {
        750: {
          slidesPerView: Math.min(2, slideCount),
          spaceBetween: 14
        }
      }
    });
  }

  function initReviewMediaSliders(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-cc-review-media]').forEach(initReviewMediaSlider);
  }

  function whenSwiperReady(cb) {
    if (typeof window.Swiper !== 'undefined') {
      cb();
      return;
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (typeof window.Swiper !== 'undefined') {
        clearInterval(timer);
        cb();
      } else if (tries > 50) {
        clearInterval(timer);
      }
    }, 100);
  }

  function initAll(root) {
    initReviewToggles(root);
    whenSwiperReady(function () {
      initReviewMediaSliders(root);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.cc-blog-review__read-more');
    if (!button) return;

    var wrap = button.closest('[data-cc-review-toggle]');
    if (!wrap) return;

    event.preventDefault();
    var expanded = wrap.getAttribute('data-expanded') === 'true';
    wrap.setAttribute('data-expanded', expanded ? 'false' : 'true');
    syncToggleLabel(wrap, button, !expanded);
  });

  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      initReviewToggles(document);
    }, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var container = event.detail && event.detail.container ? event.detail.container : event.target;
    initAll(container);
  });

  window.ccInitBlogReviewToggles = initReviewToggles;
  window.ccInitBlogReviewSliders = function (root) {
    whenSwiperReady(function () {
      initReviewMediaSliders(root);
    });
  };
  window.ccInitBlogReviews = initAll;
})();
